import { m } from '@sohanscript/i18n';
import { FilterPills } from '@sohanscript/ui/filter-pills';
import { api } from '@/lib/trpc/client';

type NotesTagFilterProps = {
	value: string | null;
	onChange: (tag: string | null) => void;
};

export function NotesTagFilter({ value, onChange }: NotesTagFilterProps) {
	const [tags] = api.note.tags.useSuspenseQuery();

	// NOTE: keep a deep-linked ?tag= visible even when it's not popular.
	const visible = value && !tags.includes(value) ? [...tags, value] : tags;

	if (visible.length === 0) return null;

	return (
		<FilterPills
			value={value}
			onChange={onChange}
			options={[
				{ value: null, label: m.note_all() },
				...visible.map((tag) => ({ value: tag, label: tag })),
			]}
			className="pb-8 md:border-secondary md:border-s md:ps-6"
		/>
	);
}
